import { Logo } from '../components/logo'
import { Link } from 'react-router-dom'
import privacyHtml from './privacy-policy.html?raw'

export function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <nav className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
        <Link to="/">
          <Logo />
        </Link>
      </nav>

      <main className="flex-1 max-w-3xl mx-auto px-6 py-12 w-full">
        <div dangerouslySetInnerHTML={{ __html: privacyHtml }} />
      </main>

      <footer className="border-t border-gray-100 px-6 py-6 flex items-center justify-between text-xs text-gray-400">
        <Logo />
        <span>© {new Date().getFullYear()} Buylog</span>
      </footer>
    </div>
  )
}
